<script>
    import { ValueService } from '../../services/ValueService.js';
    import { UsersStore } from '../../stores/UsersStore.svelte.js';

    /**
     * @typedef {import('../../types/api.d.js').ApiUsersListItem} ApiUsersListItem
     */

    /**
     * @type {{
     *     tag?: string,
     *     user_id?: number | string | null,
     *     name?: boolean,
     * }}
     */
    let { tag = 'span', user_id = 0, name = true } = $props();

    /** @type {{ [key: string]: string }} */
    const allowedTags = {
        span: 'span',
        div: 'div',
    };

    const thisTag = $derived(allowedTags[ValueService.toStringSingleLine(tag)] ?? 'span');
    const thisUserId = $derived(ValueService.toUInt(user_id));
    const thisShowName = $derived(ValueService.toBool(name));

    // -
    let thisUser = $state(/** @type {ApiUsersListItem|null} */ (null));
    $effect(() => {
        const userId = thisUserId;
        thisUser = null;
        if (userId === 0) {
            return;
        }

        UsersStore.findUserById(thisUserId).then((result) => {
            if (userId === thisUserId && result !== null) {
                thisUser = result;
            }
        });
    });

    // -
    const thisColor = $derived(
        thisUser
            ? '#' +
                  (ValueService.toStringSingleLine(thisUser.color) + '000000')
                      .toLocaleLowerCase()
                      .replace(/[^0-9a-f]/g, '')
                      .substring(0, 6)
            : '#000000'
    );
</script>

<svelte:element this={thisTag} class="flex items-center gap-2">
    {#if thisUser}
        <span
            class="m-0 block h-8 w-8 rounded-full px-0 pt-2 pb-0 text-center text-xs text-white"
            style={`background-color: ${thisColor}`}>{thisUser.userAcronym}</span>

        {#if thisShowName}
            <span class="text-base font-normal">
                {thisUser.nickName || thisUser.firstName || thisUser.userName || thisUser.userId || thisUserId}
            </span>
        {/if}
    {:else}
        #{thisUserId}
    {/if}
</svelte:element>
